export default __webpack_public_path__ + "static/media/successor_status.d4c63184.svg";